import { render, staticRenderFns } from "./reformPrototypeList.vue?vue&type=template&id=15be8290"
import script from "./reformPrototypeList.vue?vue&type=script&lang=js"
export * from "./reformPrototypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports